<template>
    <form
        action="/search"
        class="relative max-w-lg w-full"
    >
        <input
            name="search"
            type="text"
            class="block w-full rounded-xl border-0 px-6 py-4 pr-16 text-xl text-gray-900 focus:outline-none focus:ring-0"
            placeholder="Search articles..."
        />
        <button
            type="submit"
            class="absolute inset-y-0 right-4 flex items-center text-gray-900"
        >
            <Icon
                name="zoom"
                class="w-6 h-6"
            />
        </button>
    </form>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'
</script>
